import { defineComponent, computed, createElementBlock, openBlock, normalizeClass, Fragment, renderList, normalizeStyle, createElementVNode, toDisplayString } from "vue";
const BLINK = 500;
const PRINT = 100;
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FlowAsciiArt",
  props: {
    art: {},
    animate: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const lines = computed(() => props.art.split("\n"));
    const getLineAnimation = (chars, row) => ({
      animationDuration: `${chars * PRINT}ms, ${BLINK}ms`,
      animationTimingFunction: `steps(${chars}), step-end`,
      animationDelay: `${row * PRINT}ms, 0ms`,
      animationIterationCount: `1, ${(lines.value.length + lines.value[lines.value.length - 1].length + 5) * PRINT / BLINK}`
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["ascii-art", { "ascii-art-animate": _ctx.animate }])
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(lines.value, (line, i) => {
          return openBlock(), createElementBlock("span", {
            key: i,
            class: "ascii-art-line-wrapper",
            style: normalizeStyle({ width: `calc(${line.length + 1}ch)` })
          }, [
            createElementVNode("span", {
              class: "ascii-art-line",
              style: normalizeStyle(getLineAnimation(line.length, i))
            }, toDisplayString(line), 5)
          ], 4);
        }), 128))
      ], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FlowAsciiArt.vue2.js.map
